import React, { useContext, useEffect, useState } from "react";

import { Link, useLocation, useNavigate } from "react-router-dom";

import { Flip, ToastContainer, toast } from "react-toastify";

import axios from "../../api/axios";

import FloatingShape from "../../components/FloatingShape/FloatingShape";
import { motion } from "framer-motion";
import { useForm } from "react-hook-form";
import { userContext } from "../../context/UserRoleContext";
import { ArrowLeft } from "lucide-react";

import FullScreenAnimation from "../../components/fullScreenAnimation/FullScreenAnimation";
import logo from "../../assets/images/logo/logo.png";
// import "./Login.css";

function Login() {
  const { setAuthenticated } = useContext(userContext);
  const [showAnimation, setShowAnimation] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathName || "/";
  const [position, setPosition] = useState({ x: 0, y: 0 });

  // Handler for mouse move
  const handleMouseMove = (e) => {
    // console.log(e.clientX, e.clientY);
    setPosition({
      x: e.clientX, // X position of the mouse pointer relative to the viewport
      y: e.clientY, // Y position of the mouse pointer relative to the viewport
    });
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();
  useEffect(() => {}, []);

  return (
    <>
      {showAnimation ? (
        <FullScreenAnimation onAnimationEnd={() => setShowAnimation(false)} />
      ) : (
        <>
          <div className="min-h-screen  flex items-center justify-center relative overflow-hidden">
            <FloatingShape
              color="bg-green-500"
              size="w-64 h-64"
              top="-5%"
              left="10%"
              delay={0}
            />
            <FloatingShape
              color="bg-emerald-500"
              size="w-48 h-48"
              top="70%"
              left="80%"
              delay={5}
            />
            <FloatingShape
              color="bg-lime-500"
              size="w-32 h-32"
              top="40%"
              left="-10%"
              delay={2}
            />

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="max-w-md w-full p-2 m-2 bg-gray-800 bg-opacity-50 backdrop-filter backdrop-blur-xl rounded-2xl shadow-xl overflow-hidden"
              onMouseMove={handleMouseMove}
            >
              <div className="p-8">
                <span>
                  <div className="px-4 py-1 bg-gray-900 bg-opacity-50 flex justify-start">
                    <Link
                      to={"/"}
                      className="text-sm text-green-400 hover:underline flex items-center"
                    >
                      <ArrowLeft className="h-4 w-4 mr-2" />
                    </Link>
                  </div>
                </span>
                <div className="flex justify-center items-center">
                  {/* <img src={logo} className="w-mx-auto" style={{ height: "150px" }} /> */}
                </div>
                <div className=" flex flex-col items-center">
                  <div className="">
                    <div className="flex flex-col items-center">
                      <img
                        src={logo}
                        style={{
                          height: "160px",
                          transform: `translate(${position.x / 90}px, ${
                            position.y / 90
                          }px)`, // Update position dynamically
                          transition: "transform 0.1s linear", // Smooth movement
                        }}
                      />
                      {/* <button className="w-full mt-3 max-w-xs font-bold shadow-sm rounded-lg py-3 bg-green-100 text-gray-800 flex items-center justify-center transition-all duration-300 ease-in-out focus:outline-none hover:shadow focus:shadow-sm focus:shadow-outline">
                        <div className="bg-white p-2  rounded-full">
                          <svg className="w-4" viewBox="0 0 533.5 544.3">
                            <path
                              d="M533.5 278.4c0-18.5-1.5-37.1-4.7-55.3H272.1v104.8h147c-6.1 33.8-25.7 63.7-54.4 82.7v68h87.7c51.5-47.4 81.1-117.4 81.1-200.2z"
                              fill="#4285f4"
                            />
                            <path
                              d="M272.1 544.3c73.4 0 135.3-24.1 180.4-65.7l-87.7-68c-24.4 16.6-55.9 26-92.6 26-71 0-131.2-47.9-152.8-112.3H28.9v70.1c46.2 91.9 140.3 149.9 243.2 149.9z"
                              fill="#34a853"
                            />
                            <path
                              d="M119.3 324.3c-11.4-33.8-11.4-70.4 0-104.2V150H28.9c-38.6 76.9-38.6 167.5 0 244.4l90.4-70.1z"
                              fill="#fbbc04"
                            />
                            <path
                              d="M272.1 107.7c38.8-.6 76.3 14 104.4 40.8l77.7-77.7C405 24.6 339.7-.8 272.1 0 169.2 0 75.1 58 28.9 150l90.4 70.1c21.5-64.5 81.8-112.4 152.8-112.4z"
                              fill="#ea4335"
                            />
                          </svg>
                        </div>
                        <span className="ml-4">Sign In with Google</span>
                      </button> */}
                    </div>

                    <div className="mb-2  text-center">
                      <div className="leading-none text-xl  px-2 mb-2 inline-block text-sm text-gray-600 tracking-wide font-medium text-white transform translate-y-1/2">
                        Welcome Back Player!
                      </div>
                    </div>
                    <ToastContainer />

                    <div className=" ">
                      <form
                        onSubmit={handleSubmit(async (data) => {
                          // setDisabled(true);
                          // console.log(data);
                          const formData = {
                            email: data.email,
                            password: data.password,
                          };
                          toast.promise(
                            axios
                              .post("auth/login", formData, {
                                withCredentials: true,
                              })
                              .then(async function (response) {
                                // console.log(response);
                                toast.success("Login successfull! 👌", {
                                  position: "top-right",
                                  autoClose: 5000,
                                  hideProgressBar: false,
                                  closeOnClick: true,
                                  pauseOnHover: true,
                                  draggable: true,
                                  progress: undefined,
                                  theme: "colored",
                                  transition: Flip,
                                });
                                const newresponse = await response?.data;
                                const accessToken = await response?.data
                                  .accessToken;
                                const roles = await response?.data.user.role;

                                setAuthenticated({
                                  user: newresponse.user,
                                  roles: [roles],
                                  accessToken,
                                });
                                if (response.data?.user.isVerified !== true) {
                                  setShowAnimation(true);

                                  setTimeout(() => {
                                    navigate("/verifyEmail", { replace: true });
                                  }, 3000);
                                  // navigate("/");
                                } else {
                                  setShowAnimation(true);

                                  // Redirect after the animation finishes (e.g., 3 seconds delay)
                                  setTimeout(() => {
                                    navigate("/dashboard", { replace: true });
                                  }, 5000); // Adjust delay time as needed
                                }
                                // navigate("/dashboard", { replace: true });
                              })
                              .catch(async function (error) {
                                // console.log(error);
                                toast.error("There was an error! 🤯", {
                                  position: "top-right",
                                  autoClose: 5000,
                                  hideProgressBar: false,
                                  closeOnClick: true,
                                  pauseOnHover: true,
                                  draggable: true,
                                  progress: undefined,
                                  theme: "colored",
                                  transition: Flip,
                                });
                                // setDisabled(false);
                              }),
                            {
                              pending: "Please wait! we are logging you in!",
                            }
                          );
                        })}
                      >
                        <input
                          {...register("email", {
                            required: "This field is required.",
                          })}
                          className="w-full my-2 text-black px-6 py-2 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white"
                          type="email"
                          placeholder="Email"
                        />

                        <input
                          {...register("password", {
                            required: "This field is required.",
                          })}
                          className="w-full my-2 px-6 py-2 text-black rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5"
                          type="password"
                          placeholder="Password"
                        />
                        <button
                          type="submit"
                          // onClick={login}
                          className="mt-5 tracking-wide font-semibold bg-purple-700 text-white w-full py-4 rounded-lg hover:bg-purple-900 hover:text-white transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none"
                        >
                          <span className="ml-">Sign In</span>
                        </button>
                      </form>
                      <p className="mt-6 text-white text-xs text-gray-600 text-center">
                        I agree to abide by mnrhub
                        <a
                          href="#"
                          className="border-b text-xs mx-2 border-gray-500 border-dotted"
                        >
                          Terms of Service
                        </a>
                        and its
                        <a
                          href="#"
                          className="border-b mx-2 text-xs border-gray-500 border-dotted"
                        >
                          Privacy Policy
                        </a>
                      </p>
                      <p className="mt-6 text-white text-center">
                        <Link
                          to={"/forgotPassword"}
                          className="text-xs text-green-400 hover:underline"
                        >
                          ForgotPassword?
                        </Link>
                      </p>
                      <p className="mt-6 text-white text-xs text-gray-600 text-center">
                        Don't have an account?
                        <Link
                          to={"/signup"}
                          className="border-b mx-2 border-gray-500 border-dotted"
                        >
                          Sign up now
                        </Link>
                      </p>
                      {/* <button
                    onClick={() => {
                      setShowAnimation(true);
                    }}
                  >
                    load animation
                  </button> */}
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </>
      )}
    </>
  );
}

export default Login;
